<template>
	<div>
		<v-dialog v-model="showErrorPopup" persistent max-width="290">
			<v-card>
				<v-card-title class="text-h5"> Error </v-card-title>
				<v-card-text>The selected dates overlap with an existing event, please select new dates.</v-card-text>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn color="green darken-1" text @click="showErrorPopup = false"> Ok </v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
		<v-card class="elevation-3" color="white">
			<v-card-title class="secondary--text justify-center text-center">
				<v-row class="text-center justify-center p-4">
					Set Your Availability
					<v-tooltip bottom>
						<template #activator="{ on, attrs }">
							<v-icon class="ml-1" color="primary" dark v-bind="attrs" small v-on="on"> help </v-icon>
						</template>
						<span
							><v-row><v-col>Select your dates to update your calendar as either available or unavailable</v-col></v-row></span
						>
					</v-tooltip>
				</v-row>

				<v-icon color="secondary" @click="cancelLocumSetAvailability()">mdi-close</v-icon>
			</v-card-title>
			<v-divider />
			<v-card-text>
				<v-row>
					<v-col class="justify-center text-center">
						<v-btn-toggle v-model="calendarInputMode" mandatory>
							<v-btn
								rounded
								small
								:color="calendarInputMode == 0 ? 'primary' : '#FFF'"
								:class="[calendarInputMode == 0 ? 'white--text' : 'orange--text text--darken-2']"
								style="
									border-radius: 20px 0px 0px 20px;
									font-family: Montserrat;
									font-style: normal;
									font-weight: bold;
									font-size: 14px;
									line-height: 17px;
									text-align: center;
								"
							>
								Date range
							</v-btn>

							<v-btn
								rounded
								small
								:color="calendarInputMode == 1 ? 'primary' : '#FFF'"
								:class="[calendarInputMode == 1 ? 'white--text' : 'orange--text text--darken-2']"
								style="
									border-radius: 0px 20px 20px 0px;
									font-family: Montserrat;
									font-style: normal;
									font-weight: bold;
									font-size: 14px;
									line-height: 17px;
									text-align: center;
								"
							>
								Specific days
							</v-btn>
						</v-btn-toggle>
					</v-col>
				</v-row>
				<v-date-picker
					v-model="selectedDates"
					:min="new Date().toISOString().substr(0, 10)"
					header-color="primary"
					color="primary"
					full-width
					no-title
					:multiple="calendarInputMode == 1"
					:range="calendarInputMode == 0"
					class="elevation-0"
				></v-date-picker>

				<v-form ref="form" v-model="form">
					<v-row>
						<v-col>
							<v-text-field v-model="startdate" :rules="[rules.startdate]" label="Start Date:" filled dense readonly></v-text-field>
						</v-col>

						<v-col>
							<v-text-field v-model="enddate" :rules="[rules.enddate]" label="End Date:" filled dense readonly></v-text-field>
						</v-col>
					</v-row>

					<p class="font-weight-bold">Time</p>

					<v-row>
						<v-col>
							<v-dialog ref="starttimedialog" v-model="starttimemodal" :return-value.sync="starttime" persistent width="290px">
								<template #activator="{ on }">
									<v-text-field v-model="starttime" label="Start Time:" placeholder="Start Time:" readonly filled dense v-on="on"></v-text-field>
								</template>
								<v-time-picker v-if="starttimemodal" v-model="starttime" full-width format="24hr" :allowed-minutes="[0, 15, 30, 45]">
									<v-spacer></v-spacer>
									<v-btn text color="primary" @click="starttimemodal = false">Cancel</v-btn>
									<v-btn text color="primary" @click="$refs.starttimedialog.save(starttime)">OK</v-btn>
								</v-time-picker>
							</v-dialog>
						</v-col>

						<v-col>
							<v-dialog ref="endtimedialog" v-model="endtimemodal" :return-value.sync="endtime" persistent width="290px">
								<template #activator="{ on }">
									<v-text-field v-model="endtime" label="End Time" placeholder="End Time:" readonly filled dense v-on="on"></v-text-field>
								</template>
								<v-time-picker v-if="endtimemodal" v-model="endtime" full-width format="24hr" :allowed-minutes="[0, 15, 30, 45]">
									<v-spacer></v-spacer>
									<v-btn text color="primary" @click="endtimemodal = false">Cancel</v-btn>
									<v-btn text color="primary" @click="$refs.endtimedialog.save(endtime)">OK</v-btn>
								</v-time-picker>
							</v-dialog>
						</v-col>
					</v-row>

					<v-row>
						<v-col>
							<v-select
								v-model="availabilityOption"
								:items="offerOptions"
								:value="'Available'"
								filled
								:rules="[v => !!v || 'Offer type is required']"
								dense
								label="Mark days as"
								no-data-text="No more options to select"
								hide-selected
								required
							></v-select>
						</v-col>
					</v-row>
				</v-form>
			</v-card-text>

			<v-card-actions>
				<v-spacer />
				<v-btn depressed :disabled="!form" rounded color="green" class="white--text text-none" :loading="apiRequest" @click="doLocumSetAvailability">
					<span>{{ isAvailability ? 'Confirm availability' : 'Confirm unavailability' }}</span>
					<v-icon right>mdi-arrow-right</v-icon>
				</v-btn>

				<v-spacer />

				<span v-if="hasError" class="text--red text-center">An Error occurred.</span>
			</v-card-actions>

			<v-spacer />
		</v-card>
	</div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import moment from 'moment';
import { bus } from '@/main';

import store from '@/store';
import { getDefaultShiftTimes } from '@/utils/util';

export default {
	name: 'LocumSetAvailability',
	components: {},
	data: () => ({
		user: store.getters.user,
		calendarInputMode: 0,
		form: false,

		showErrorPopup: false,

		range: [moment().format('YYYY-MM-DD'), moment().format('YYYY-MM-DD')],

		today: moment(),
		startdatemodal: false,
		enddatemodal: false,

		starttime: '09:00',
		endtime: '17:00',

		startdate: null,
		enddate: null,
		minDate: new Date().toISOString().substr(0, 10),

		starttimemodal: false,
		endtimemodal: false,

		hasError: false,

		selectedDatesSorted: [],

		industriesConfigsObj: store.getters.configs.industries,

		availabilityOption: 'Available',

		offerOptions: ['Available', 'Unavailable'],

		apiRequest: false,

		rules: {
			startdate: v => !!v || 'Start date required',
			enddate: v => !!v || 'End date required',
		},
	}),
	computed: {
		...mapGetters('bookings', ['professionalConfirmedBookings', 'professionalBookingsRequests']),

		...mapGetters('availability', ['professionalAvailability']),

		selectedDates: {
			get: function () {
				return this.selectedDatesSorted;
			},
			set: function (newValue) {
				this.selectedDatesSorted = newValue.sort((a, b) => moment(a).diff(b, 'days'));
			},
		},
		userProfession() {
			return this.user.profession || null;
		},

		computedstartDateFormattedMomentjs() {
			return this.startdate ? moment(this.startdate).format('dddd, MMMM Do YYYY') : '';
		},
		computedendDateFormattedMomentjs() {
			return this.enddate ? moment(this.enddate).format('dddd, MMMM Do YYYY') : '';
		},
		availsetting() {
			if (this.availabilityOption === 'Available') {
				return 'open';
			}
			if (this.availabilityOption === 'Unavailable') {
				return 'unavailable';
			} else {
				return 'open';
			}
		},
		relevantProfessions() {
			if (this.user.industry) {
				return this.industriesConfigsObj[this.user.industry];
			} else {
				return [];
			}
		},
		isAvailability() {
			return this.availabilityOption === 'Available';
		},
	},
	watch: {
		selectedDatesSorted() {
			this.checkExistingEvents();
			this.startdate = this.selectedDatesSorted[0];
			this.enddate = this.selectedDatesSorted[this.selectedDatesSorted.length - 1];
		},
	},
	created() {
		const { start, end } = getDefaultShiftTimes(this.tenant);
		this.starttime = start;
		this.endtime = end;
	},
	methods: {
		...mapActions('availability', ['UpsertAvailability']),

		allowedEndDates(val) {
			return this.startdate ? moment(val).isSameOrAfter(moment(this.startdate)) : true;
		},
		allowedStartDates(val) {
			return this.enddate ? moment(val).isSameOrBefore(moment(this.enddate)) : true;
		},

		allowedDatesAll(val) {
			return this.allowedEndDates(val) && this.allowedStartDates(val);
		},

		functionEvents(date) {
			const [, , day] = date.split('-');
			if ([12, 17, 28].includes(parseInt(day, 10))) return true;
			if ([1, 19, 22].includes(parseInt(day, 10))) return ['primary', 'accent'];
			return false;
		},

		cancelLocumSetAvailability() {
			bus.$emit('change-context', 'locum-dashboard-landing-zone');
		},

		isTwoDayShift(start_time, end_time, date) {
			const start = moment(`${date} ${start_time}`);
			let end = moment(`${date} ${end_time}`);
			return moment(start).isAfter(end);
		},

		async doLocumSetAvailability() {
			this.apiRequest = true;
			const user = store.getters.user;

			let dates = [];
			if (this.calendarInputMode == 1) {
				dates = this.selectedDatesSorted;
			} else {
				let startDay = this.selectedDatesSorted[0];
				let endDay = this.selectedDatesSorted[this.selectedDatesSorted.length - 1];
				const countDays = startDay === endDay ? 0 : moment(endDay).startOf('day').diff(moment(startDay).endOf('day'), 'days') + 1;

				for (let day_index = 0; day_index <= countDays; day_index++) {
					let day = moment(startDay).add(day_index, 'days');
					dates.push(day.format('YYYY-MM-DD'));
				}
			}

			const canCreateAvailability = this.checkExistingEvents(dates);
			if (!canCreateAvailability) {
				this.apiRequest = false;
				this.showErrorPopup = true;
				return;
			}

			const start_date = dates[0];
			const end_date = dates[dates.length - 1];

			const start_time_iso = moment(`${start_date} ${this.starttime}`).format();
			let end_time_iso = moment(`${end_date} ${this.endtime}`).format();

			const multipleDayShift = this.isTwoDayShift(this.starttime, this.endtime, start_date);
			if (multipleDayShift) {
				end_time_iso = moment(end_time_iso).add('days', 1).format();
			}

			const { experience, locations, languages, willing_to_travel, working_hours, skills = [] } = user;

			const body = {
				status: this.availsetting,
				start_time: this.starttime,
				end_time: this.endtime,
				start_time_iso,
				end_time_iso,
				start_date,
				end_date,
				profession: this.userProfession,
				rates: {
					weekdays: working_hours.weekdays.rate,
					public_holidays: working_hours.public_holidays.rate,
					saturday: working_hours.saturday.rate,
					sundays: working_hours.sundays.rate,
				},
				locations,
				languages,
				skills,
				willing_to_travel,
				available_dates: dates,
				experience: experience
					? {
							start_date: moment(experience.start_date).format('YYYY-MM-DD'),
							companies_worked_for: experience.companies_worked_for || [],
					  }
					: moment().format('YYYY-MM-DD'),
				companies_worked_for: experience?.companies_worked_for || [],
			};

			try {
				await this.UpsertAvailability(body);
				store.commit('PUSH_NOTIFICATION', { component: 'locum-availability-created', data: [''] });
				bus.$emit('change-context', 'locum-dashboard-landing-zone');
				setTimeout(() => {
					bus.$emit('UpdateCalendar');
				}, 500);
			} catch (err) {
				this.hasError = true;
			} finally {
				this.apiRequest = false;
			}
		},
		checkOverlap(timeSegments) {
			if (timeSegments.length === 1) return false;

			timeSegments.sort((timeSegment1, timeSegment2) => timeSegment1[0].localeCompare(timeSegment2[0]));

			for (let i = 0; i < timeSegments.length - 1; i++) {
				const currentEndTime = timeSegments[i][1];
				const nextStartTime = timeSegments[i + 1][0];

				if (currentEndTime > nextStartTime) {
					return true;
				}
			}

			return false;
		},
		checkExistingEvents(dates = []) {
			let requestsBlocker = false;
			let confirmedBlocker = false;
			let availabilityBlocker = false;
			const selectedTime = [this.starttime, this.endtime];
			if (this.professionalConfirmedBookings) {
				confirmedBlocker = this.professionalConfirmedBookings.some(booking =>
					booking?.booking_dates?.some(date => dates.includes(date) && this.checkOverlap([selectedTime, [booking.start_time, booking.end_time]]))
				);
			}
			if (this.professionalAvailability) {
				availabilityBlocker = this.professionalAvailability.some(availability =>
					availability?.available_dates?.some(date => dates.includes(date) && this.checkOverlap([selectedTime, [availability.start_time, availability.end_time]]))
				);
			}
			return !requestsBlocker && !confirmedBlocker && !availabilityBlocker;
		},
	},
};
</script>
